/** @prettier */
import { List } from 'immutable';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { subscribeToEvent, unsubscribeToEvent } from '@xanadu/ui-shared/modules/event/actions';
import { subscribeToMarket, unsubscribeToMarket } from '@xanadu/ui-shared/modules/market/actions';
import { removeSelectionFromMultipleByCids } from '@xanadu/ui-shared/modules/multiples/actions';
import { getMultipleBuildSelections } from '@xanadu/ui-shared/modules/multiples/selectors';
import {
  getEventIdForRunner,
  getEventNameForRunner,
  getMarketIdForRunnerId,
  getMarketNameForRunner,
  getMarketTypeForRunner,
  getSportUrlNameForRunner,
} from '@xanadu/ui-shared/modules/runner/selectors';
import { removeOffersByCids } from '@xanadu/ui-shared/modules/unsubmittedOffers/actions';

import { triggerUpdateRightSidebar } from '../../../modules/rightSidebar/actions';

import Selection from '../../../components/Multiples/Selection';

const mapDispatchToProps = {
  removeSelectionFromMultipleByCids,
  subscribeToEvent,
  unsubscribeToEvent,
  subscribeToMarket,
  unsubscribeToMarket,
  updateRightSidebar: triggerUpdateRightSidebar,
  removeOffersByCids,
};

const makeGetSelectionInfo = () =>
  createSelector(
    (state, props) => getMarketIdForRunnerId(state, props.runnerId),
    (state, props) => getEventIdForRunner(state, props.runnerId),
    (state, props) => getMarketNameForRunner(state, props.runnerId),
    (state, props) => getMarketTypeForRunner(state, props.runnerId),
    (state, props) => getEventNameForRunner(state, props.runnerId),
    (state, props) => getSportUrlNameForRunner(state, props.runnerId),
    (state) => getMultipleBuildSelections(state),
    (marketId, eventId, marketName, marketType, eventName, sportUrlName, currentSelections) => {
      const errors = [];
      const groupedSelections = currentSelections.groupBy((s) => s.get('eventId'));
      const duplicatedSelections = groupedSelections.get(eventId) || new List([]);

      if (duplicatedSelections.size > 1) {
        errors.push({ priority: 7, key: 'multiple-legs', message: 'Only one leg per event' });
      }

      return {
        errors,
        marketId,
        eventId,
        marketName,
        marketType,
        eventName,
        sportUrlName,
      };
    }
  );

const makeMapStateToProps = () => {
  const getSelectionInfo = makeGetSelectionInfo();

  const mapStateToProps = (state, ownProps) => {
    const runner = state.getIn(['runner', ownProps.runnerId]);

    const {
      errors,
      marketId,
      eventId,
      marketName,
      marketType,
      eventName,
      sportUrlName,
      gradingResult,
    } = getSelectionInfo(state, {
      ...ownProps,
      eventId: runner.get('eventId'),
    });

    if (ownProps.side === 'lay' || ownProps.side === 'lose') {
      const side = ownProps.side.charAt(0).toUpperCase() + ownProps.side.substring(1);
      errors.push({
        priority: 2,
        key: 'side-not-allowed',
        message: `${side} selections not permitted`,
      });
    }

    return {
      id: `${runner.get('id')}_${ownProps.side}`,
      runnerName: runner.get('name'),
      side: ownProps.side,
      marketId,
      eventId,
      marketName,
      marketType,
      eventName,
      sportUrlName,
      errors: errors.sort((e1, e2) => (e1.priority < e2.priority ? -1 : 1)),
      gradingResult,
      widthSize: state.getIn(['application', 'widthSize'], ''),
      selectionErrors: state.getIn(['multiples', 'selectionErrors']),
    };
  };

  return mapStateToProps;
};

export default connect(makeMapStateToProps, mapDispatchToProps)(Selection);
